import { useEffect, useState } from "react";
import { authService } from "../utils/authService";
import axiosInstance from "../utils/axiosConfig";

export const useScheduleForm = (
  selectedSchedule,
  fetchSchedules,
  setModalIsOpen
) => {
  const [formData, setFormData] = useState({
    client_id: selectedSchedule?.client_id || "",
    user_id: selectedSchedule?.user_id || "",
    service_type: selectedSchedule?.service_type || "",
    start_time: selectedSchedule?.start_time || "",
    end_time: selectedSchedule?.end_time || "",
    description: selectedSchedule?.description || "",
    location_id: selectedSchedule?.elevator?.building?.location?.id || "",
    building_id: selectedSchedule?.elevator?.building?.id || "",
    elevator_id: selectedSchedule?.elevator_id || "",
  });

  useEffect(() => {
    if (selectedSchedule) {
      setFormData({
        start_time: selectedSchedule.start_time.slice(0, 16),
        end_time: selectedSchedule.end_time.slice(0, 16),
        description: selectedSchedule.description,
        user_id: selectedSchedule.user_id,
        client_id: selectedSchedule?.client_id || "",
        service_type: selectedSchedule.service_type,
        location_id: selectedSchedule?.elevator?.building?.location?.id || "",
        building_id: selectedSchedule?.elevator?.building?.id || "",
        elevator_id: selectedSchedule?.elevator_id || "",
      });
    }
  }, [selectedSchedule]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const status =
      formData.user_id && formData.client_id ? "assigned" : "pending";
    const submitData = { ...formData, status };

    const url = selectedSchedule
      ? `${process.env.REACT_APP_API_URL}/schedules/${selectedSchedule.id}`
      : `${process.env.REACT_APP_API_URL}/schedules`;
    const method = selectedSchedule ? "PATCH" : "POST";

    const response = await axiosInstance({
      method: method,
      url: url,
      data: { schedule: submitData },
    });

    fetchSchedules();
    setModalIsOpen(false);

    return true;
  };

  return { formData, setFormData, handleSubmit };
};
